/* Header for application. Ideally messages to the user about application status will also go here. */
import React, { Component } from "react";
import PropTypes from "prop-types";
import CFG from "./Configconstants";

class Header extends Component {
    render() { 
    var messageDiv = '';
    if(this.props.messageStatus){
        messageDiv = <div class="systemmessage">{this.props.messageStatus}</div>
    }  
    return(
    <div class="headerclass">
	<h2>Cend</h2>
	<span class="sysdetails">Version {CFG.CENDVERSION} by JLO2</span>
    <span class="subtitle">A send-only client to demonstrate REST programming against an application engine.</span>
    {messageDiv}
    
    </div>);
    }
}
export default Header


// WEBPACK FOOTER //
// ./src/Header.js